import { Modal } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Waypoint } from 'react-waypoint';
import { ReactComponent as Contact } from '../../../../../assets/icon/contactSupport.svg';

import styles from '../Style/PricingModal.module.scss';
import {
  DataFileFormatsTable,
  HostingTable,
  MultiPointDiscountGraph,
  MultiPointDiscountTable,
  SubscriptionTable,
  TimeSeriesTable,
} from './PricingComponents';
import useHomeStore from "../../../../../store/homeStore";
import {useSelectedDataset} from "../../../../layout/Header/components/SearchBar";
import useSearchStore from "../../../../../store/searchStore";

type PrivateProps = {
  visible: boolean;
  onHandlePricingModalCancel: () => void;
  handleCloseAllModals: () => void;
};

export default function PricingModal({
  visible,
  onHandlePricingModalCancel,
  handleCloseAllModals,
}: PrivateProps) {
  const navigate = useNavigate();

  const [activeLink, setActiveLink] = useState('oneOfPurchase');
  const setSearchId = useSearchStore(state => state.setSearchId)
  const setDropdownSearchbarOpen = useHomeStore(state => state.setDropdownSearchbarOpen)
  const { onChange }= useSelectedDataset((id) => setSearchId(id))
  return (
    <Modal
      className={`pricingModal ${styles.pricingModal}`}
      title={[
        <div
          className={styles.titleContainer}
          key={'pricingModal-title-container'}
        >
          <h1>Pricing</h1>
          <div>
            Our priced services include
            <a href="#oneOfPurchase"> One-off purchase</a>,
            <a href="#subscription"> Subscription</a> and
            <a href="#hosting"> Hosting</a>.
          </div>
        </div>,
      ]}
      open={visible}
      onCancel={onHandlePricingModalCancel}
      // width={'65vw'}
      footer={[
        <div key="pricingModal-footerText"></div>,
        //  <Button key="back" onClick={handleAnalyticsCancel}>Close</Button>
      ]}
    >
      <div className={styles.pricingModalContent}>
        <div className={styles.listNavigation}>
          <a
            className={`${activeLink === 'oneOfPurchase' ? styles.active : ''}`}
            href="#oneOfPurchase"
          >
            One-off purchase
          </a>
          <a
            className={`${activeLink === 'subscription' ? styles.active : ''}`}
            href="#subscription"
          >
            Subscription
          </a>
          <a
            className={`${activeLink === 'hosting' ? styles.active : ''}`}
            href="#hosting"
          >
            Hosting
          </a>
        </div>

        <div className={styles.content}>
          <section id="oneOfPurchase">
            <div className={styles.sectionContainer}>
              {/* <Waypoint onPositionChange={(e) => e.currentPosition === "inside" && setActiveLink("oneOfPurchase")}> */}
              <Waypoint onPositionChange={() => setActiveLink('oneOfPurchase')}>
                <h2> One-off purchase</h2>
              </Waypoint>
              <p>
                All prices are exclusive of any taxes and duties (such as VAT
                and WHT).
              </p>
              <p>
                A one-off purchase involves online payment and instant access to
                time series data.
              </p>

              <h3>Price of time series data</h3>
              <p>
                Time series data is priced in EUR per point per year (min. 1
                year).
              </p>
              <p>
                The <span>general</span> pricing by category and type is outlined below. The
                price includes all variables of the respective dataset. Detailed
                specifications and price are given in the metadata of the datasets.
              </p>
              <TimeSeriesTable />

              <h3>Price of data reports</h3>
              <p>
                <span
                 className={styles.spanLink}
                 onClick={() => {
                  handleCloseAllModals();
                  navigate('features#data-report');
                }}
              >Data reports
              </span>are priced at €15,000.- per point. The price includes license fee for derived use of the time series data,
                but it does <span style={{textDecoration: 'underline'}}>not</span> include delivery of the time series data. Customized reports are available upon request.</p>

              <h3>Multi-point discount </h3>
              <p>
                Multiple points of time series data from the same dataset are
                discounted (at checkout):
              </p>
              <div className={styles.discountContainer}>
                <MultiPointDiscountGraph />
                <MultiPointDiscountTable />
              </div>
              <h3 id="quantumDiscount">Quantum discount </h3>
              <p>
                Are you looking to acquire many points, not all at once, but
                over a prolonged period, when and where the need arises?
              </p>
              <p>Then you may ask for a quantum discount.</p>
              <p>
                With a quantum discount your account is assigned credits which
                are pre-purchased at a discounted rate. One credit equal €1. The
                credits can be used to download time series data. The credits
                cannot be combined with other discounts (such as multi-point
                discount).
              </p>
              <div
                // onClick={() => navigate('contact')}
                onClick={() => {
                  handleCloseAllModals();
                  navigate('contact');
                }}
                className={styles.contactContainer}
              >
                <Contact className={styles.svg} />
                <p>
                  <span>Contact</span> us for an offer.
                </p>
              </div>

              <Waypoint
                onPositionChange={(e) =>
                  e.currentPosition === 'inside' &&
                  setActiveLink('oneOfPurchase')
                }
              >
                {/* <Waypoint onPositionChange={() => setActiveLink('oneOfPurchase')}> */}
                <h3>Data file formats </h3>
              </Waypoint>
              <p>
                The time series data is delivered in the following file formats:
              </p>
              <DataFileFormatsTable />
              <p>
                The data is extracted as discrete (non-interpolated) values of
                the model grid cell.
              </p>

              <h3>Delivery method </h3>
              <p>
                Within a few minutes after completing checkout, you will receive
                an email with a link to download the time series data in a .zip
                file (2D spectra and 3D currents may take up to about 1 hour).
              </p>
              <p>The download link is valid for 30 days.</p>
              <p>
                <span
                  className={styles.spanLink}
                  onClick={() => {
                    handleCloseAllModals();
                    setDropdownSearchbarOpen(true)
                  }}
                >
                  Datasets
                </span>
                metadata,
                <span
                  className={styles.spanLink}
                  onClick={() => {
                    handleCloseAllModals();
                    navigate('features#validation');
                  }}
                >
                  Validation
                </span>
                ,
                <span
                  className={styles.spanLink}
                  onClick={() => {
                    handleCloseAllModals();
                    navigate('features#analytics');
                  }}
                >
                  Analytics
                </span>
                , and
                <span
                  className={styles.spanLink}
                  onClick={() => {
                    handleCloseAllModals();
                    navigate('features#data-report');
                  }}
                >
                  Reports
                </span>
                are available online only (not provided by email).
              </p>

              <h3>Payment methods </h3>
              <p>
                One-off purchases are paid online by Credit card (VISA,
                MasterCard).
              </p>
              <p>
                <a href="#quantumDiscount">Quantum discount</a>,
                <a href="#subscription">Subscription</a> and
                <a href="#hosting">Hosting</a> are paid by invoice (bank
                transfer).
              </p>
            </div>
          </section>

          <section id="subscription">
            <div className={styles.sectionContainer}>
              <Waypoint
                onPositionChange={(e) =>
                  e.currentPosition === 'inside' &&
                  setActiveLink('subscription')
                }
              >
                {/* <Waypoint onPositionChange={() => setActiveLink('subscription')}> */}
                <h2>Subscription</h2>
              </Waypoint>
              <p>
                A subscription grants you unlimited* access to the DHI metocean
                data Portal.
              </p>
              <p>
                See options below and
                <span
                  className={styles.spanLink}
                  onClick={() => {
                    handleCloseAllModals();
                    navigate('contact');
                  }}
                >
                  Contact
                </span>
                us to define the right solution for your business.
              </p>
              <p>* Terms and conditions apply.</p>
              <SubscriptionTable handleCloseAllModals={handleCloseAllModals} />
            </div>
          </section>

          <section id="hosting">
            <div className={styles.sectionContainer}>
              <Waypoint
                onPositionChange={(e) =>
                  e.currentPosition === 'inside' && setActiveLink('hosting')
                }
              >
                {/* <Waypoint onPositionChange={() => setActiveLink('hosting')}> */}
                <h2>Hosting</h2>
              </Waypoint>
              <p>
              Let us host the DHI metocean data of your project. This makes it easy for you to access and analyze the data immediately,
              and to share it across your organization and with relevant partners and contractors. We already host many private datasets
              for several clients in a secure and confidential manner.
              </p>
              <p>
                A recent example is the metocean database of Dutch waters hosted for<a
                  href="https://offshorewind.rvo.nl/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  RVO
                </a>, see fx
                <a
                  href="https://www.metocean-on-demand.com/?coor=%5B4.281933%2C53.795952%5D&SW=waterdata-dataset-DWF23_SW_WRF&HD=waterdata-dataset-DWF23_HD_WRF&Wind=waterdata-dataset-DWF23_AT_WRF_1h"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  P1
                </a>
                . This database is public (FREE) and includes the following datasets: Waves: `
                <span
                  className={styles.spanLink}
                  onClick={() => {
                    handleCloseAllModals()
                    onChange('waterdata-dataset-DWF23_SW_WRF')
                  }}
                >
                  DWF23_SW_WRF
                </span>`, Ocean: `<span
                  className={styles.spanLink}
                  onClick={() => {
                    handleCloseAllModals()
                    onChange('waterdata-dataset-DWF23_HD_WRF')
                  }}
                >
                  DWF23_HD_WRF
                </span>`, Atmosphere: `<span
                  className={styles.spanLink}
                  onClick={() => {
                    handleCloseAllModals()
                    onChange('waterdata-dataset-DWF23_AT_WRF_1h')
                  }}
                >
                  DWF23_AT_WRF_1h
                </span>`, etc.
              </p>
              <HostingTable handleCloseAllModals={handleCloseAllModals} />
              <div>
              <p>
                The hosted data is free to download (up to 15 downloads per day) and free to use for metocean analytics for up to 5 accounts.
                The hosting includes metocean support (up to 1 hour per month), and the general services (validation and API access)
                of a subscription.
              </p>
                <div
                  onClick={() => {
                    handleCloseAllModals();
                    navigate('contact');
                  }}
                  className={styles.contactContainer}
                >
                  <Contact className={styles.svg} />
                  <p>
                    <span>Contact</span> us to discuss hosting options for your project.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Modal>
  );
}
